<div>
    <div *ngIf="_categories.length > 0">
        <mat-toolbar color="primary">
            <div></div>
        </mat-toolbar>
        <div *ngIf="_categories.length > 2" class="horizontal-scroll small-padding sticky background" style="z-index: 1999;" id="categorypicker">
            <button mat-stroked-button style="margin: 5px; color: whitesmoke;" *ngFor="let category of _categories" (click)="categoryTap(category.ID)" id="button{{category.ID}}">{{category.Name}}</button>
        </div>
        <div *ngFor="let category of _categories" id="{{category.ID}}">
            <div class="large-padding background sticky" id="header{{category.ID}}">
                <div class="label" style="font-size: 20px; color: whitesmoke;">{{category.Name}}</div>
                <div class="detail"  style="color: lightgray;"> {{category.Description}}</div>
            </div>
            <div *ngFor="let item of category.Itens" matRipple class="no-outline pointer-cursor" (click)="goToItem(item)">
                <div class="flex-container-center">
                    <div class="thumbnail-holder small-margin-vertical small-padding-vertical">
                        <img src="{{item.Thumbnail}}" class="thumbnail" onerror="this.src='assets/img/placeholder.png'">
                    </div>
                    <div class="small-margin small-padding">
                        <div>
                            <div class="label block">{{item.Name}}</div>
                            <div class="detail block"> {{item.SubDescription}}</div>
                        </div>
                    </div>
                    <div *ngIf="!item.OutOfStock" class="block float-right small-margin small-padding" style="text-align: right; white-space: nowrap;">
                        <div class="original-price-label">{{item.OriginalPriceString}}</div>
                        <div class="block float-right price-label">{{item.PriceString}}</div>
                    </div>
                    <div *ngIf="item.OutOfStock" class="block float-right price-label small-margin small-padding">{{'Pages.CategoryItens.Unavailable' | translate}}</div>
                </div>
                <mat-divider></mat-divider>
            </div>
        </div>
        <mat-toolbar color="primary">
            <div></div>
        </mat-toolbar>
    </div>
    <div *ngIf="_categories.length === 0" class="floating-container">
        <div class="logo-image-holder">
            <img src="assets/img/no_content.png" class="logo-image" onerror="this.src='assets/img/no_content.png'">
        </div>
    </div>
    <mat-toolbar *ngIf="showOrderBar" class="bar-filler"></mat-toolbar>
    <mat-toolbar color="primary" class="top-bar" id="topbar">
        <button *ngIf="isRedirect !== true" mat-icon-button (click)="back()">
            <mat-icon>arrow_back</mat-icon>
        </button>
        <button *ngIf="isRedirect === true" mat-icon-button (click)="goHome()">
            <mat-icon>home</mat-icon>
        </button>
        <div>{{'Pages.MenuCategories.Title' | translate}}</div>
        <div class="filler"></div>
    </mat-toolbar>
    <mat-toolbar *ngIf="showOrderBar" matRipple #bottomBar id="bottomBar" [matRippleDisabled]="true" color="primary" class="bottom-bar">
        <button mat-flat-button color="accent" (click)="goToOrder()" class="fill-parent-width">{{'Pages.MenuCategories.SeeOrder' | translate}}({{orderitemcount}})</button>
    </mat-toolbar>
</div>